import { REDUCER_NAME } from './const';

const NS = REDUCER_NAME + '/';

export const GET_PARTIAL_REFUND_DATA_REQUEST = NS + 'GET_PARTIAL_REFUND_DATA_REQUEST';
export const GET_PARTIAL_REFUND_DATA_SUCCESS = NS + 'GET_PARTIAL_REFUND_DATA_SUCCESS';
export const GET_PARTIAL_REFUND_DATA_ERROR = NS + 'GET_PARTIAL_REFUND_DATA_ERROR';

export const GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST = NS + 'GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST';
export const GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS = NS + 'GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS';
export const GET_REFUNDABLE_SALES_ORDER_LIST_ERROR = NS + 'GET_REFUNDABLE_SALES_ORDER_LIST_ERROR';

export const SAVE_PARTIAL_REFUND_DATA_REQUEST = NS + 'SAVE_PARTIAL_REFUND_DATA_REQUEST';
export const SAVE_PARTIAL_REFUND_DATA_SUCCESS = NS + 'SAVE_PARTIAL_REFUND_DATA_SUCCESS';
export const SAVE_PARTIAL_REFUND_DATA_ERROR = NS + 'SAVE_PARTIAL_REFUND_DATA_ERROR';

export const CHANGE_PARTIAL_REFUND_DATA = NS + 'CHANGE_PARTIAL_REFUND_DATA';
export const ADD_VALIDATION_MESSAGE = NS + 'ADD_VALIDATION_MESSAGE';
export const CLEAR_VALIDATION_MESSAGE_LIST = NS + 'CLEAR_VALIDATION_MESSAGE_LIST';



// WEBPACK FOOTER //
// ./src/modules/partial-refund/state/type.js